import React from 'react';


const Spinner = (props) => {
    const h = props.height ? props.height : '3rem';
    const w = props.height ? props.height : '3rem';
    const color = props.color ? props.color : 'default';
    
    return (
        <div className={"spinner-border text-" + color} style={{width: w, height: h}} role="status">
            <span className="sr-only">Loading...</span>
        </div>);
}
export default Spinner;